import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnCls } from "./LoginCard";
import { FileOrLink } from "./FileOrLink";

export const UpcomingPanel = ({ upcoming, onSaved }) => {
  const [form, setForm] = useState({ enabled: true, title: "", teaser: "", release_date: "", cover: "", ...upcoming, release_date: upcoming?.release_date ?? "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/upcoming", { ...form, release_date: form.release_date || null });
      toast.success("Coming soon drop updated");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} data-testid="admin-upcoming-form" className="space-y-4">
      <p className="text-zinc-300">Leave the title empty to keep it a mystery. Add a date to show a live countdown.</p>
      <input data-testid="admin-upcoming-title" className={inputCls} placeholder="Title (optional)" value={form.title} onChange={set("title")} />
      <textarea data-testid="admin-upcoming-teaser" rows={3} className={inputCls} placeholder="Teaser line" value={form.teaser} onChange={set("teaser")} />
      <label className="block">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Release date &amp; time (optional)</span>
        <input data-testid="admin-upcoming-date" type="datetime-local" className={`${inputCls} mt-2`} value={form.release_date?.slice(0, 16) ?? ""} onChange={set("release_date")} />
      </label>
      <FileOrLink testid="admin-upcoming-cover" accept="image/*" placeholder="Cover image link (optional)" value={form.cover} onChange={(v) => setForm({ ...form, cover: v })} />
      <button data-testid="admin-upcoming-save" disabled={busy} className={btnCls}>Save</button>
    </form>
  );
};
